<script setup>
import VideoPlayer from './VideoPlayer.vue'

// eslint-disable-next-line no-unused-vars
const props = defineProps({
  size: String,
  title: String,
  category: String,
  link: String,
  image_url: String,
  video_url: String,
  autoplay: Boolean,
})
</script>

<template>
  <router-link :to="link" class="project-card" :class="[`project-card_${size}`]">
    <VideoPlayer
      :video-url="video_url"
      :cover-image="image_url"
      :title="title"
      :category="category"
      :size="size"
      :autoplay="autoplay"
      class="video-title"
    />
  </router-link>
</template>

<style scoped>
.project-card {
  display: block;
  width: 100%;
  text-decoration: none;
  position: relative;
  max-width: 50rem;
  margin: 0 auto;
  outline: none;
  -webkit-tap-highlight-color: transparent;
}

.project-card_video :deep(.video-player) {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.project-card_video :deep(.video-player__aspect-ratio) {
  height: 100%;
  padding: 0;
}
</style>
